import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/enroll_course_validate`, {params: {...filter}})
  },

}
